import { render } from "./SignupMultipleNewsletters.vue?vue&type=template&id=1c5dd8d0"
import script from "./SignupMultipleNewsletters.vue?vue&type=script&lang=js"
export * from "./SignupMultipleNewsletters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__